import { Box } from '@televet/kibble-ui/build/chakra';
import { Menu, MenuItemProps, MenuListOnSelect, MenuListOnSelectAll } from '@televet/kibble-ui/build/components/Menu';
import React from 'react';

interface TerminalFilterMenuProps {
  menuItems: MenuItemProps[];
  onSelect: MenuListOnSelect;
  onSelectAll: MenuListOnSelectAll;
}

const TerminalFilterMenu = ({ menuItems, onSelect, onSelectAll }: TerminalFilterMenuProps): JSX.Element => {
  return (
    <Box className="PaymentReport__TerminalFilterMenu">
      <Menu
        isLazy
        buttonProps={{
          leftIconName: 'cellphone',
          rightIconName: 'chevronDown',
          size: 'sm',
          text: 'Terminal Name',
          variant: 'secondary',
        }}
        listProps={{
          canSelectAll: true,
          canSelectGroups: false,
          isMultiSelect: true,
          isSearchable: true,
          onSelect,
          menuItems,
          onSelectAll,
        }}
      />
    </Box>
  );
};

const customComparator = (prevProps: TerminalFilterMenuProps, nextProps: TerminalFilterMenuProps): boolean =>
  JSON.stringify(prevProps.menuItems) === JSON.stringify(nextProps.menuItems);

export default React.memo(TerminalFilterMenu, customComparator);
